<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm"
	*ngIf="UserModuleAccess==='Full'">
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('com_name')}" id="com_name"
					formControlName="com_name" placeholder="">
				<label for="com_name">Name</label>
			</div>
			<p *ngIf="showError('com_name')" class="text-danger">
				<span *ngIf="f.com_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.com_name.errors?.incorrect">
					{{customError.com_name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('EmailId')}" id="EmailId"
					formControlName="EmailId" placeholder="">
				<label for="EmailId">Email</label>
			</div>
			<p *ngIf="showError('EmailId')" class="text-danger">
				<span *ngIf="f.EmailId.errors?.required">
					Required
				</span>
				<span *ngIf="f.EmailId.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.EmailId.errors?.incorrect">
					{{customError.EmailId}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('comp_address')}" id="comp_address"
					formControlName="comp_address" placeholder="">
				<label for="comp_address">Address</label>
			</div>
			<p *ngIf="showError('comp_address')" class="text-danger">
				<span *ngIf="f.comp_address.errors?.required">
					Required
				</span>
				<span *ngIf="f.comp_address.errors?.incorrect">
					{{customError.comp_address}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('comp_full_address')}"
					id="comp_full_address" formControlName="comp_full_address" placeholder="">
				<label for="comp_full_address">Secondary Address</label>
			</div>
			<p *ngIf="showError('comp_full_address')" class="text-danger">
				<span *ngIf="f.comp_full_address.errors?.required">
					Required
				</span>
				<span *ngIf="f.comp_full_address.errors?.incorrect">
					{{customError.comp_full_address}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<p class="text-center"><label> Drop a Logo</label></p>
			<app-file-upload [allowedFiles]="allowedLogoFiles" (selected)="onFileSelect($event)" [upload]="false"
				[disabled]="true">
			</app-file-upload>
		</div> -->
		<div *ngIf="co_logo" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<p><label>Existing Logo:</label></p>
			<a [href]="File_Storage_URL + co_logo" target="_blank">
				<img [src]="File_Storage_URL + co_logo" class="company-logo" alt="Logo" />
			</a>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Back</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>